/* Sit&Cut — Custom JS — Direct port from example HTML files */
(function() {
  'use strict';

  /* Scroll progress bar */
  var progressBar = document.querySelector('.sc-scroll-progress');
  var mainNav = document.querySelector('.sc-nav');
  if (progressBar || mainNav) {
    window.addEventListener('scroll', function() {
      var s = document.documentElement.scrollTop;
      var d = document.documentElement.scrollHeight - window.innerHeight;
      if (progressBar) progressBar.style.transform = 'scaleX(' + (d > 0 ? s / d : 0) + ')';
      if (mainNav) mainNav.classList.toggle('scrolled', window.scrollY > 60);
    }, {passive: true});
  }

  /* Reveal animations */
  var ro = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, {threshold: 0.08, rootMargin: '0px 0px -60px 0px'});
  document.querySelectorAll('.sc-reveal,.sc-reveal-left,.sc-reveal-right').forEach(function(el) { ro.observe(el); });

  /* FAQ toggle */
  document.addEventListener('click', function(e) {
    var item = e.target.closest('.sc-faq-item, .sc-faq-card');
    if (!item) return;
    var list = item.parentElement;
    var wasOpen = item.classList.contains('open');
    if (list) list.querySelectorAll('.open').forEach(function(i) { i.classList.remove('open'); });
    if (!wasOpen) item.classList.add('open');
  });

  /* Gallery thumbnail switching (product page) */
  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('.sc-gallery-thumb');
    if (!thumb) return;
    var gallery = thumb.closest('.sc-gallery');
    if (!gallery) return;
    var mainImg = gallery.querySelector('.sc-gallery-main img');
    if (mainImg && thumb.dataset.src) {
      mainImg.src = thumb.dataset.src;
      if (thumb.dataset.alt) mainImg.alt = thumb.dataset.alt;
      gallery.querySelectorAll('.sc-gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    }
  });

  /* Mobile swipe galleries */
  document.querySelectorAll('.sc-gallery-mobile-track').forEach(function(track) {
    if (track.dataset.scGalleryReady === 'true') return;
    track.dataset.scGalleryReady = 'true';

    var gallery = track.closest('.sc-gallery-mobile');
    var dots = gallery ? gallery.querySelectorAll('.sc-gallery-dot') : [];
    if (!dots.length) return;

    function updateDots() {
      var idx = Math.round(track.scrollLeft / track.offsetWidth);
      dots.forEach(function(dot, i) {
        dot.classList.toggle('active', i === idx);
      });
    }

    track.addEventListener('scroll', updateDots, { passive: true });
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var idx = parseInt(dot.getAttribute('data-idx'), 10) || 0;
        track.scrollTo({ left: idx * track.offsetWidth, behavior: 'smooth' });
      });
    });
  });

  /* Quantity selector */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.sc-qty-btn');
    if (!btn) return;
    var wrap = btn.closest('.sc-qty-wrap');
    if (!wrap) return;
    var val = wrap.querySelector('.sc-qty-val');
    var input = wrap.querySelector('input[name="quantity"]');
    if (!val) return;
    var n = parseInt(val.textContent) || 1;
    if (btn.dataset.action === 'minus' && n > 1) n--;
    if (btn.dataset.action === 'plus') n++;
    val.textContent = n;
    if (input) input.value = n;
  });

  function isUnavailableVariantInput(input) {
    var button = input.closest('.sc-variant-button');
    return input.disabled ||
      input.getAttribute('aria-disabled') === 'true' ||
      input.dataset.optionAvailable === 'false' ||
      (button && (
        button.classList.contains('sc-variant-button--unavailable') ||
        button.dataset.optionAvailable === 'false'
      ));
  }

  var variantDataCache = new WeakMap();

  function getVariantData(picker) {
    if (variantDataCache.has(picker)) return variantDataCache.get(picker);

    var panel = picker.closest('.sc-variant-panel');
    var source = panel ? panel.querySelector('.sc-product-variants-json') : null;
    var variants = [];

    if (source && source.textContent) {
      try {
        variants = JSON.parse(source.textContent);
      } catch (err) {
        console.warn('Could not parse product variants', err);
      }
    }

    if (!Array.isArray(variants)) variants = [];
    variantDataCache.set(picker, variants);
    return variants;
  }

  function getVariantOptions(variant) {
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter(function(option) {
      return typeof option === 'string' && option.length;
    });
  }

  function variantMatchesValues(variant, values) {
    var options = getVariantOptions(variant);
    return values.every(function(value, index) {
      return !value || options[index] === value;
    });
  }

  function hasAvailableVariantForValues(variants, values) {
    return variants.some(function(variant) {
      return variant && variant.available && variantMatchesValues(variant, values);
    });
  }

  function setVariantInputAvailability(input, isAvailable) {
    var value = isAvailable ? 'true' : 'false';
    var button = input.closest('.sc-variant-button');

    input.dataset.optionAvailable = value;
    if (isAvailable) {
      input.removeAttribute('aria-disabled');
    } else {
      input.setAttribute('aria-disabled', 'true');
    }

    if (button) {
      button.dataset.optionAvailable = value;
      button.classList.toggle('sc-variant-button--unavailable', !isAvailable);
    }
  }

  function updateComputedVariantAvailability(picker) {
    if (!picker) return;

    var variants = getVariantData(picker);
    if (!variants.length) return;

    var fieldsets = Array.prototype.slice.call(picker.querySelectorAll('.sc-variant-fieldset'));
    var selectedValues = fieldsets.map(function(fieldset) {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : '';
    });

    fieldsets.forEach(function(fieldset, fieldsetIndex) {
      fieldset.querySelectorAll('input[type="radio"]').forEach(function(input) {
        var candidateValues = selectedValues.slice();
        candidateValues[fieldsetIndex] = input.value;
        setVariantInputAvailability(input, hasAvailableVariantForValues(variants, candidateValues));
      });
    });
  }

  function findAvailableVariantInput(fieldset) {
    var inputs = Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"]'));
    return inputs.find(function(input) {
      return !isUnavailableVariantInput(input);
    });
  }

  function repairUnavailableVariantSelection(picker) {
    if (!picker || picker.dataset.scRepairingSelection === 'true') return;

    var replacement = null;
    var shouldMoveFocus = false;
    picker.querySelectorAll('.sc-variant-fieldset').forEach(function(fieldset) {
      if (replacement) return;
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      if (!checked || !isUnavailableVariantInput(checked)) return;
      shouldMoveFocus = document.activeElement === checked;
      replacement = findAvailableVariantInput(fieldset);
    });

    if (!replacement || replacement.checked) return;

    picker.dataset.scRepairingSelection = 'true';
    replacement.checked = true;
    replacement.dispatchEvent(new Event('change', { bubbles: true }));
    if (shouldMoveFocus) {
      try {
        replacement.focus({ preventScroll: true });
      } catch (err) {
        replacement.focus();
      }
    }

    window.setTimeout(function() {
      delete picker.dataset.scRepairingSelection;
    }, 0);
  }

  function isBlackOptionValue(value) {
    if (!value) return false;
    var h = String(value).toLowerCase().trim();
    return h === 'fekete' || h === 'black';
  }

  function updateColorDeliveryNote(picker) {
    if (!picker) return;
    var panel = picker.closest('.sc-variant-panel');
    if (!panel) return;
    var note = panel.querySelector('.sc-color-delivery-note');
    if (!note) return;
    var fieldsets = Array.prototype.slice.call(picker.querySelectorAll('.sc-variant-fieldset'));
    if (!fieldsets.length) return;
    var allBlack = fieldsets.every(function(fieldset) {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      return checked && isBlackOptionValue(checked.value);
    });
    note.classList.toggle('sc-color-delivery-note--visible', !allBlack);
  }

  document.addEventListener('change', function(e) {
    var input = e.target.closest('variant-picker.sc-native-variant-picker input[type="radio"]');
    if (!input) return;
    var picker = input.closest('variant-picker.sc-native-variant-picker');
    if (!picker || picker.dataset.scRepairingSelection === 'true') return;

    window.requestAnimationFrame(function() {
      updateComputedVariantAvailability(picker);
      repairUnavailableVariantSelection(picker);
      updateColorDeliveryNote(picker);
    });
  });

  document.addEventListener('variant:update', function(e) {
    var target = e.target;
    var picker = target && target.matches && target.matches('variant-picker')
      ? target
      : target && target.closest
        ? target.closest('variant-picker')
        : null;

    if (!picker || !picker.classList.contains('sc-native-variant-picker')) return;

    window.requestAnimationFrame(function() {
      updateComputedVariantAvailability(picker);
      repairUnavailableVariantSelection(picker);
      updateColorDeliveryNote(picker);
    });
  });

  window.requestAnimationFrame(function() {
    document.querySelectorAll('variant-picker.sc-native-variant-picker').forEach(function(picker) {
      updateComputedVariantAvailability(picker);
      repairUnavailableVariantSelection(picker);
      updateColorDeliveryNote(picker);
    });
  });

  function pulseCartButton() {
    var cartButton = document.querySelector('.sc-nav-cart');
    if (!cartButton) return;
    cartButton.classList.remove('sc-cart-pulse');
    void cartButton.offsetWidth;
    cartButton.classList.add('sc-cart-pulse');
  }

  function animateFlyToCart(source, image) {
    var cartButton = document.querySelector('.sc-nav-cart');
    if (!cartButton || !source || !window.customElements || !customElements.get('fly-to-cart')) {
      pulseCartButton();
      return;
    }

    var flyToCartElement = document.createElement('fly-to-cart');
    if (image) {
      flyToCartElement.style.setProperty('background-image', 'url(' + image + ')');
    } else {
      flyToCartElement.style.setProperty('background', 'linear-gradient(135deg, var(--sc-gold), var(--sc-gold-light))');
    }
    flyToCartElement.source = source;
    flyToCartElement.destination = cartButton;
    document.body.appendChild(flyToCartElement);
  }

  function getCartErrorMessage() {
    return (window.Theme && window.Theme.translations && window.Theme.translations.cart_error) || 'Could not add the product to the cart.';
  }

  function getAddingToCartMessage() {
    return (window.Theme && window.Theme.translations && window.Theme.translations.adding_to_cart) || 'Adding...';
  }

  /* Keep custom cart count in sync with native Shopify product-form events */
  document.addEventListener('cart:update', function() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        if (typeof cart.item_count !== 'number') return;
        document.querySelectorAll('.sc-nav-cart-count').forEach(function(count) {
          count.textContent = cart.item_count;
        });
        pulseCartButton();
      })
      .catch(function(error) {
        console.warn('Cart count refresh failed', error);
      });
  });

  /* Cart drawer open from custom nav */
  document.addEventListener('click', function(e) {
    var cartBtn = e.target.closest('.sc-nav-cart');
    if (!cartBtn) return;
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      drawer.setAttribute('open', '');
      var dialog = drawer.querySelector('dialog');
      if (dialog && dialog.showModal) { try { dialog.showModal(); } catch(err) {} }
    }
  });

  /* Add product forms to cart without navigating away */
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('.sc-product-form');
    if (!form) return;

    var submitter = e.submitter;
    if (!submitter && document.activeElement && form.contains(document.activeElement) && document.activeElement.matches('[data-sc-cart-action]')) {
      submitter = document.activeElement;
    }
    if (!submitter || submitter.dataset.scCartAction !== 'add') return;

    e.preventDefault();

    var message = form.querySelector('.sc-cart-message');
    var originalText = submitter.innerHTML;
    submitter.disabled = true;
    submitter.classList.add('is-loading');
    submitter.innerHTML = getAddingToCartMessage();

    if (message) {
      message.hidden = true;
      message.textContent = '';
    }

    var formData = new FormData(form);
    var cartItemsComponents = document.querySelectorAll('cart-items-component');
    var sectionIds = [];

    cartItemsComponents.forEach(function(component) {
      if (component.dataset.sectionId) sectionIds.push(component.dataset.sectionId);
    });

    if (sectionIds.length) {
      formData.append('sections', Array.from(new Set(sectionIds)).join(','));
      formData.append('sections_url', window.location.pathname);
    }

    fetch((window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || getCartErrorMessage());
          }
          return data;
        });
      })
      .then(function(data) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: data,
            sourceId: form.id || 'sc-product-form',
            data: {
              source: 'sc-product-form',
              itemCount: Number(formData.get('quantity')) || 1,
              variantId: String(formData.get('id') || ''),
              sections: data.sections || {}
            }
          }
        }));

        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function(cartResponse) { return cartResponse.json(); })
          .then(function(cart) {
            if (typeof cart.item_count === 'number') {
              document.querySelectorAll('.sc-nav-cart-count').forEach(function(count) {
                count.textContent = cart.item_count;
              });
            }
            return data;
          })
          .catch(function(cartError) {
            console.warn('Cart count refresh failed', cartError);
            return data;
          });
      })
      .then(function() {
        if (message) {
          message.textContent = '';
          message.hidden = true;
        }
        animateFlyToCart(submitter);
      })
      .catch(function(error) {
        if (message) {
          message.textContent = error.message || getCartErrorMessage();
          message.hidden = false;
        }
      })
      .finally(function() {
        submitter.disabled = false;
        submitter.classList.remove('is-loading');
        submitter.innerHTML = originalText;
      });
  });

  /* Mobile hamburger menu toggle */
  document.addEventListener('click', function(e) {
    var hamburger = e.target.closest('.sc-nav-hamburger');
    if (!hamburger) return;
    var nav = hamburger.closest('.sc-nav');
    if (!nav) return;
    var isOpen = nav.classList.toggle('mobile-open');
    hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  /* Close mobile menu when a link is clicked */
  document.addEventListener('click', function(e) {
    var link = e.target.closest('.sc-nav-links a');
    if (!link) return;
    var nav = link.closest('.sc-nav');
    if (!nav) return;
    nav.classList.remove('mobile-open');
    var hamburger = nav.querySelector('.sc-nav-hamburger');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
  });

  /* Smooth scroll for same-page anchor links */
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (href === '#') return;
    var target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);

  var privacyBannerPromise;

  function loadPrivacyBanner() {
    if (window.privacyBanner) return Promise.resolve(window.privacyBanner);
    if (privacyBannerPromise) return privacyBannerPromise;

    privacyBannerPromise = new Promise(function(resolve, reject) {
      var existing = document.querySelector('script[src*="privacy-banner/storefront-banner.js"]');
      if (existing) {
        existing.addEventListener('load', function() { resolve(window.privacyBanner); }, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
      script.async = true;
      script.onload = function() { resolve(window.privacyBanner); };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return privacyBannerPromise;
  }

  function openCookiePreferences(button) {
    loadPrivacyBanner()
      .then(function(banner) {
        if (banner && typeof banner.showPreferences === 'function') {
          return banner.showPreferences();
        }
        if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.showPreferences === 'function') {
          window.Shopify.customerPrivacy.showPreferences();
          return;
        }
        throw new Error('Shopify privacy banner is not available.');
      })
      .catch(function(error) {
        console.warn('Cookie preferences modal failed to open', error);
        if (button && button.dataset.fallbackUrl) {
          window.location.href = button.dataset.fallbackUrl;
        }
      });
  }

  /* Footer legal menu: open Shopify cookie preferences */
  document.addEventListener('click', function(e) {
    var button = e.target.closest('[data-sc-cookie-preferences]');
    if (!button) return;
    e.preventDefault();
    openCookiePreferences(button);
  });

})();
